import styled from 'styled-components';

export const ImageWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
`;

export const PreviewImage = styled.img`
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: contain;
  margin-top: 5px;
`;
